// src\stores\reducers\index.ts
import device from './device';
import wallet from './wallet';
import loadControll from './loading';
import commonControll from './common';
import projectControll from './project';
import sideSlice from './side';
import gameSlice from './game';
import userSlice from './user';
import accessHistory from './accessHistory';
// import customGasPrice from './customGasPrice';

export default {
  device: device.reducer,
  wallet: wallet.reducer,
  loadControll: loadControll.reducer,
  projectControll: projectControll.reducer,
  side: sideSlice.reducer,
  game: gameSlice.reducer,
  user: userSlice.reducer,
  accessHistory: accessHistory.reducer,
  common: commonControll.reducer,
  // customGasPrice: customGasPrice.reducer
}



// import { combineReducers } from 'redux';

// import projectControll from './project';
// import sideSlice from './side';

// export default combineReducers({
//   projectControll
// });